import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

// Wrapper around sonner.toast that suppresses toast.error() when a structured
// trial-limit modal is being shown (so the user does not see both a raw error
// toast AND the friendly modal).
const _isSuppressed = () => {
  try {
    const until = Number(window.__tabelloneSuppressToastUntil || 0);
    return until > Date.now();
  } catch {
    return false;
  }
};

const toast = new Proxy(sonnerToast, {
  get(target, prop) {
    if (prop === "error") {
      return (...args) => {
        if (_isSuppressed()) return undefined;
        return target.error(...args);
      };
    }
    return target[prop];
  },
});

export { Toaster, toast }
